import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-placement-team',
  templateUrl: './placement-team.component.html',
  styleUrls: ['./placement-team.component.scss']
})
export class PlacementTeamComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
